import Icon from '../components/Icon.vue'

Icon.register({
  torah: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M48 0c26.5 0 48 21.5 48 48v80h-80c-8.8 0-16-7.2-16-16v-64c0-26.5 21.5-48 48-48zM395.1 228.6l17.4-29.2 17.5 29.2h-34.9zM336.1 280.6l-16.8-28.1h33.6zM242 228.6l17.4-29.2 17.5 29.2h-34.9zM430 123.4l-17.4 29.2-17.5-29.2h34.9zM256 412.6c0 31.9-21.8 61.4-53.3 66.5-2.9 0.5-7.8 0.9-10.8 0.9-35.3 0-64-28.7-64-64v0-368c-0.1-14.8-7.4-36.3-16.4-48h336.4c52.9 0.1 95.9 43.1 96 96v256h-288v60.6zM217.4 109.6c-1.4 2.5-2.6 6.9-2.6 9.8 0 3 1.3 7.6 2.9 10.2l27.8 46.4-27.7 46.3c-1.6 2.6-2.8 7.2-2.8 10.3 0 11 9 20 20 20h56.4l27.7 46.3c3.1 5.3 10.7 9.7 16.9 9.7 0 0 0 0 0.1 0 6.3 0 14-4.4 17.2-9.8l27.6-46.1h56.3 0c6.4 0 14.3-4.5 17.5-10.2 1.5-2.5 2.6-6.9 2.6-9.8 0-3-1.3-7.6-2.9-10.2l-27.8-46.4 27.7-46.3c1.6-2.6 2.9-7.2 2.9-10.3 0-11-9-20-20-20h-56.4l-27.7-46.3c-3.1-5.3-10.7-9.7-16.9-9.7 0 0 0 0-0.1 0 0 0 0 0 0 0-6.3 0-14 4.4-17.2 9.8l-27.6 46.1h-56.3 0c-6.4 0-14.3 4.5-17.5 10.2zM624 384c8.8 0 16 7.2 16 16 0 61.8-50.2 112-112 112h-336c52.9-0.1 95.9-43.1 96-96v-32h336zM276.9 123.4l-17.4 29.2-17.5-29.2h34.9zM336 71.4l16.8 28.1h-33.6zM304.9 228.6l-31.5-52.6 31.4-52.6h62.3l31.5 52.6-31.4 52.6h-62.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/torah.js
// module id = null
// module chunks = 